import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SelectedBuildingModel } from 'src/app/views/components/utils/selected-building.model';
import { SelectedItemUtil } from 'src/app/views/components/utils/selected-item.utils';

@Component({
  selector: 'app-checkbox-list',
  templateUrl: './checkbox-list.component.html',
  styles: [],
})
export class CheckboxListComponent {
  @Input() building: SelectedBuildingModel;
  selectedBuildingIds: Array<string> = [];
  @Output() selectionChange = new EventEmitter<any>();

  constructor(private selectedItemUtil: SelectedItemUtil) {}

  toggleCheckbox(id: string): void {
    if (this.selectedBuildingIds.includes(id)) {
      this.selectedBuildingIds = this.selectedBuildingIds.filter(
        (i) => i !== id
      );
      this.selectionChange.emit({ id: id, add: false });
    } else {
      this.selectedBuildingIds.push(id);
      this.selectionChange.emit({ id: id, add: true });
    }

    // this.selectionChange.emit(this.selectedBuildings);
    // this.selectedItemutil.formatAddress(item);
    // if (this.selectedItems.includes(item)) {
    //   this.selectedItems = this.selectedItems.filter((i) => i !== item);
    // } else {
    //   this.selectedItems.push(item);
    // }
    // this.selectionChange.emit(this.selectedItems);
  }

  formatAddress(item: SelectedBuildingModel): string {
    return this.selectedItemUtil.formatAddress(item);
  }
}
